import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IManagedAccountAccessToken } from './types';

export function useManagedAccountAccessTokenMutation({
	onSuccess,
	onError,
	onSettled,
}: {
	onSuccess?: (data: IManagedAccountAccessToken) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSettled?: () => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation<
		IManagedAccountAccessToken,
		Api.IOperationResultNoValue,
		{ managedAccountId: string; userId: string }
	>({
		mutationFn: params =>
			userSession.webServiceHelper.callAsync<IManagedAccountAccessToken>({
				path: `ManagedAccount/${params.managedAccountId}/users/${params.userId}/accessToken`,
				method: 'POST',
			}),
		onSuccess,
		onError,
		onSettled,
	});
}
